import api from '../api'

export default {
    namespaced: true,
    state: {
        list: []
    },
    mutations: {
        setRankRewardList(state, info) {
            state.list = info
        }
    },
    getters: {
        getRankReward(state) {
            return state.list;
        }
    },
    actions: {
        getRankRewardList(store) {
            return api.post(`/rankReward/list`, '指定对应的排名奖励')
        },
        addRankReward(store, {...params}) {
            return api.post(`/rankReward/add/`, '新增排名奖励', params)
        },
        updateRankReward(store, params) {
            return api.post(`/rankReward/update/`, '修改排名奖励', params)
        },
        deleteRankReward(store, id) {
            return api.post(`/rankReward/del/${id}`, '删除排名奖励')
        },

    }
}